import React, { useEffect, useState } from "react";
import "../../styles/Modals.css";
import ClosedIcon from "../../icons/ClosedIcon";
import RequestAdditionalDocumentsIcon from "../../icons/RequestAdditionalDocumentsIcon";
import { translateLabel, translateText, useTranslationSnapshot } from "./../../translations/runtime";


function RequestDocsModal({
  error,
  isSubmitting = false,
  reasonMessage = "",
  onClose,
  onConfirm,
}) {
  useTranslationSnapshot();
  const [message, setMessage] = useState("");

  useEffect(() => {
    setMessage(reasonMessage);
  }, [reasonMessage]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>

        <div className="modal-close" onClick={onClose}>
          <ClosedIcon />
        </div>

        <div className="modal-icon-circle modal-icon-circle-orange">
          <RequestAdditionalDocumentsIcon />
        </div>

        <div className="modal-title">Request Additional Documents</div>
        <div className="modal-subtitle">
          Specify what additional documentation is needed from the vendor.
        </div>

        <div className="modal-form">
          <div className="modal-form-label">Document Request<span>*</span></div>
          <textarea
            className="modal-textarea"
            placeholder={translateLabel("txt_admin_please_provide_additional_certificate_for", "Please provide additional certificate for...")}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        {error && <div className="modal-error">{translateText(error)}</div>}

        <div className="modal-footer">
          <button
            className="modal-btn-cancel"
            disabled={isSubmitting}
            onClick={onClose}
          > {translateLabel("btn_cancel", "Cancel")} </button>
          <button
            className="modal-btn-send"
            disabled={isSubmitting}
            onClick={() => onConfirm(message)}
          >
            {isSubmitting ? translateLabel("txt_end_user_sending", "Sending...") : translateLabel("txt_admin_send_request", "Send Request")}
          </button>
        </div>

      </div>
    </div>
  );
}

export default RequestDocsModal;
